module.exports = __webpack_public_path__ + "static/media/gc-created.99b9b93b.svg";